import { Target } from "./target";

const msgNew = "Create new uncropped areas";
const msgExtend = "Extend perennial crops";

export class TargetCategory {
    constructor(public readonly targets: Target[], public readonly title: string) { }

    static create(targets: Target[]): TargetCategory[] {
        const categories: TargetCategory[] = [];

        const newCrops = targets.filter((t) => !t.perennial);
        if (newCrops.length) {
            categories.push(new TargetCategory(newCrops, msgNew));
        }

        const perennial = targets.filter((t) => t.perennial);
        if (perennial.length) {
            categories.push(new TargetCategory(perennial, msgExtend));
        }

        return categories;
    }

    /**
     * "visible" if any of its children are visible or selected.
     */
    get visible() {
        return !!this.targets.length;
    }
}
